import { RefreshCw } from "lucide-react";

type Props = {
  onReload: () => void;
};

const ReloadButton: React.FC<Props> = ({ onReload }) => {
  return (
    <button
      onClick={onReload}
      className="p-2 rounded-md hover:bg-gray-100 active:bg-gray-200 transition-colors"
      aria-label="Reload"
    >
      <RefreshCw className="w-5 h-5 text-gray-600" />
    </button>
  );
};

export default ReloadButton;
